// removed by extract-text-webpack-plugin
module.exports = {"header":"footer-1r2","resource-list":"footer-2rU","collapsed-resources":"footer-xfB","resource":"footer-2PW","icon":"footer-2tA"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/Footer/MainContent/Resource/resource.module.scss
// module id = 298
// module chunks = 0